import { leerEmailPersistido, useSessionStore } from '@/core/auth/sessionStore';
let refreshPromise = null;
/**
 * Llama a /auth/refresh usando el refresh y email disponibles (en memoria
 * o persistidos). Actualiza los tokens en el store y devuelve el nuevo
 * access. Exportada para que el bootstrap inicial de App pueda disparar
 * un refresh proactivo (Symfony devuelve 403 cuando no hay header de auth
 * en absoluto, así que no alcanza con el ciclo 401→retry del interceptor).
 */
export async function solicitarRefresh(client) {
    const { refreshToken, usuario } = useSessionStore.getState();
    const email = usuario?.email ?? leerEmailPersistido();
    if (!refreshToken || !email)
        throw new Error('SIN_REFRESH_TOKEN');
    const res = await client.post('/api/gestion/v1/auth/refresh', { refresh: refreshToken, email }, { headers: { 'X-Skip-Auth': '1' } });
    const { access, refresh } = res.data;
    useSessionStore.getState().setAccessToken(access);
    useSessionStore.getState().setRefreshToken(refresh);
    return access;
}
/**
 * Dedupe: si ya hay un refresh en vuelo, devolvemos ese promise.
 */
export function refrescarSesionCompartido(client) {
    if (!refreshPromise) {
        refreshPromise = solicitarRefresh(client).finally(() => {
            refreshPromise = null;
        });
    }
    return refreshPromise;
}
export function setupRefreshInterceptor(client) {
    client.interceptors.response.use((r) => r, async (error) => {
        const status = error.response?.status;
        const original = error.config;
        if (status !== 401 || !original || original.headers?.['X-Skip-Auth']) {
            throw error;
        }
        const yaReintentado = original._retry;
        if (yaReintentado) {
            useSessionStore.getState().limpiar();
            throw error;
        }
        original._retry = true;
        try {
            const nuevo = await refrescarSesionCompartido(client);
            if (original.headers) {
                original.headers.Authorization = `Bearer ${nuevo}`;
            }
            return client(original);
        }
        catch (e) {
            useSessionStore.getState().limpiar();
            throw e;
        }
    });
}
